import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06d2b992")

_pushScopeId("data-v-06d2b992")
const _hoisted_1 = { class: "item-after display-flex align-items-center" }
const _hoisted_2 = { style: {"text-align":"end"} }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "block-title no-margin",
  style: {"padding-left":"20px"}
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "display-flex update"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_popover = _resolveComponent("f7-popover")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_f7_list_item, {
      class: "store-list-item",
      title: _ctx.item.name,
      header: _ctx.item.sku,
      footer: _ctx.item.notes
    }, {
      media: _withId(() => [
        (!_ctx.item.hasError)
          ? (_openBlock(), _createBlock(_component_f7_link, {
              key: 0,
              "popover-open": '.popover-' + _ctx.hashcodeOf(_ctx.item.number)
            }, {
              default: _withId(() => [
                _createVNode("div", {
                  class: "part-image",
                  style: `background-image: url('${_ctx.item.imageUrl}')`
                }, null, 4)
              ]),
              _: 1
            }, 8, ["popover-open"]))
          : (_openBlock(), _createBlock(_component_f7_icon, {
              key: 1,
              f7: "exclamationmark_octagon",
              color: "red"
            }))
      ]),
      after: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            (_ctx.showPrice)
              ? (_openBlock(), _createBlock("div", _hoisted_3, _toDisplayString(_ctx.item.formattedPrice), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode("div", null, "+" + _toDisplayString(_ctx.item.loyaltyPoints * _ctx.item.count) + " Points", 513), [
              [_vShow, _ctx.item.loyaltyPoints > 0]
            ])
          ]),
          (_ctx.readonly || _ctx.item._sku.charAt(0) == 'J')
            ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.item.count), 1))
            : (_openBlock(), _createBlock("div", _hoisted_5, [
                (_ctx.item.count == 0)
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 0,
                      class: "add",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.item.updateCount(1))),
                      fill: "",
                      "icon-f7": "cart_badge_plus",
                      text: "Add to cart"
                    }))
                  : (_openBlock(), _createBlock("div", _hoisted_6, [
                      _createVNode(_component_f7_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.item.updateCount(-1))),
                        fill: "",
                        "icon-f7": "minus"
                      }),
                      _createVNode("input", {
                        type: "number",
                        readonly: "",
                        value: _ctx.item.count
                      }, null, 8, ["value"]),
                      _createVNode(_component_f7_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.item.updateCount(1))),
                        fill: "",
                        "icon-f7": "plus"
                      })
                    ]))
              ]))
        ])
      ]),
      _: 1
    }, 8, ["title", "header", "footer"]),
    _createVNode(_component_f7_popover, {
      class: 'popover-' + _ctx.hashcodeOf(_ctx.item.number)
    }, {
      default: _withId(() => [
        _createVNode("div", {
          class: "part-image-large",
          style: `background-image: url('${_ctx.item.imageUrl}')`
        }, null, 4)
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
})